export default __webpack_public_path__ + "static/Remote-Access-984d62612d5f838c4344fd13a6ea61ad.webp";